<template>
    <div class="config-group-outline px-prj2 py-prj px-3@large border mt-prj3">
        <div class="row my-children-2">
            <div class="small-12 column">
                <h2 class="h3 mt-0 mb-0">{{group.title}}</h2>
            </div>
        </div>
        <slot/>
    </div>
</template>

<script>

    export default {
        name: "OptionGroup.vue",
        props: ['group'],
        components: {  }
    }
</script>

<style scoped>
.dropflex {
    width: 100%
}
</style>